The criteria to filter position openings by.

These are `PositionOpening`-specific extensions on top of the standard pagination arguments `after` and `first`.
